module.exports = __webpack_public_path__ + "img/setup2.1e321d60.jpg";